import { toast } from "react-toastify";
import { get, post, put } from "../../../services/api";
import { ADD_JOB_FAILED, CONFIRMED_GET_JOBS, GET_JOBS_FAILED_ACTION, CONFIRMED_GET_ALL_JOBS,CONFIRMED_GET_SINGLE_JOBS } from "./jobTypes";
import { isPastDate, dateFormat } from "../../../utils/date";

export function addJobFailedAction(data) {
  return {
    type: ADD_JOB_FAILED,
    payload: data,
  };
}

export function getJobList(data) {
  return {
    type: CONFIRMED_GET_JOBS,
    payload: data,
  };
}

export function getAllJobList(data) {
  return {
    type: CONFIRMED_GET_ALL_JOBS,
    payload: data,
  };
}


export function getSingleJobList(data) {
  return {
    type: CONFIRMED_GET_SINGLE_JOBS,
    payload: data,
  };
}


export function companyjobFailedAction(data) {
  return {
    type: GET_JOBS_FAILED_ACTION,
    payload: data,
  };
}

export function getCompanyJob(id, token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/job/company/" + id, token);
      dispatch(getJobList(res));
    } catch (e) {
      dispatch(
        companyjobFailedAction("Something went wrong while fetching companies..")
      );
    }
  };
}


export function getAllJobs(token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/job", token);
      dispatch(getAllJobList(res));
    } catch (e) {
      dispatch(
        companyjobFailedAction("Something went wrong while fetching companies..")
      );
    }
  };
}


export function getRequirementById(id, token) {
  return async (dispatch) => {
    try {
      const res = await get("/api/job/"+id, token);
      dispatch(getSingleJobList(res));
    } catch (e) {
      dispatch(
        companyjobFailedAction("Something went wrong while fetching companies..")
      );
    }
  };
}

export function addJob(data, setModal, token, isAll = false, resetForm) {
  return async (dispatch) => {
    try {
      const jobData = JSON.parse(JSON.stringify(data));
      
      if (jobData.jobStartDate) {
        jobData.jobStartDate = new Date(jobData.jobStartDate);
      }
      
      if (jobData.jobEndDate) {
        const endDate = new Date(jobData.jobEndDate);
        endDate.setHours(23, 59, 59, 999);
        jobData.jobEndDate = endDate;
      }
      
      const candidatesList = jobData.candidatesList || [];
      const originalJobId = jobData.originalJobId;
      delete jobData.candidatesList;
      delete jobData.originalJobId;
      
      const res = await post("/api/job", jobData, token);
      if (res.status === 200 || res.status === 201) {
        const newJobId = res.data._id;
        
        if (originalJobId && candidatesList.length > 0) {
          try {
            const candidateIds = candidatesList.map(c => c.candidateId);
            
            if (candidateIds.length > 0) {
              const candidates = candidateIds.map(id => ({ _id: id }));
              
              const candidatePayload = { 
                candidates: candidates
              };
              
              console.log("Extending job with candidates:", candidatePayload);
              const hireRes = await put(`/api/job/${newJobId}/hire`, candidatePayload, token);
              
              if (hireRes.status === 200 || hireRes.status === 201) {
                toast.success("Job extended with candidates successfully.");
              } else {
                toast.warning("Job added but failed to extend all candidates.");
              }
            } else {
              toast.warning("No candidates found to extend. Job added without candidates.");
            }
          } catch (error) {
            console.error("Error extending candidates:", error);
            toast.warning("Job added but failed to extend candidates: " + (error.message || "Unknown error"));
          }
        } else {
          toast.success("Job added successfully.");
        }
        
        if (isAll) {
          const res = await get("/api/job", token);
          dispatch(getAllJobList(res));
        } else {
          const res = await get("/api/job/company/" + jobData?.companyId, token);
          dispatch(getJobList(res));
        }
        setModal(false);
        if (resetForm) {
          resetForm();
        }
      } else {
        dispatch(
          addJobFailedAction(
            "Something went wrong while adding job. Please try again"
          )
        );
      }
    } catch (e) {
      console.error("Error in addJob:", e);
      dispatch(
        addJobFailedAction(
          "Something went wrong while adding job. Please try again"
        )
      );
    }
  };
}


export function updateJob(data, id, setModal, token) {
  return async (dispatch) => {
    try {
      const jobData = JSON.parse(JSON.stringify(data));
      
      if (jobData.jobStartDate) {
        jobData.jobStartDate = new Date(jobData.jobStartDate);
      }
      
      if (jobData.jobEndDate) {
        const endDate = new Date(jobData.jobEndDate);
        endDate.setHours(23, 59, 59, 999);
        jobData.jobEndDate = endDate;
      }
      
      const res = await put("/api/job/"+id, jobData, token);
      if (res.status === 200 || res.status === 201) {
        toast.success("Job updated successfully.");
        const res = await get("/api/job/company/" + jobData?.companyId, token);
        dispatch(getJobList(res));
        setModal(false);
      } else {
        dispatch(
          addJobFailedAction(
            "Something went wrong while updating job. Please try again"
          )
        );
      }
    } catch (e) {
      dispatch(
        addJobFailedAction(
          "Something went wrong while updating job. Please try again"
        )
      );
    }
  };
}


export function updateRequirement(data, id, token) {
  return async (dispatch) => {
    try {
      const jobData = JSON.parse(JSON.stringify(data));
      
      if (jobData.jobStartDate) {
        jobData.jobStartDate = new Date(jobData.jobStartDate);
      }
      
      if (jobData.jobEndDate) {
        const endDate = new Date(jobData.jobEndDate);
        endDate.setHours(23, 59, 59, 999);
        jobData.jobEndDate = endDate;
      }
      
      const res = await put("/api/job/"+id, jobData, token);
      if (res.status === 200 || res.status === 201) {
        toast.success("Requirement updated successfully.");
        const res = await get("/api/job", token);
        dispatch(getAllJobList(res));
      } else {
        dispatch(
          addJobFailedAction(
            "Something went wrong while updating requirement. Please try again"
          )
        );
      }
    } catch (e) {
      dispatch(
        addJobFailedAction(
          "Something went wrong while updating requirement. Please try again"
        )
      );
    }
  };
}

export function hireCandidate(data, id, token) {
  return async (dispatch) => {
    try {
      if (!data.candidates || !Array.isArray(data.candidates)) {
        throw new Error("Invalid candidates data");
      }
      
      console.log("Hiring candidates with data:", data);

      const invalidCandidates = [];
      const validCandidates = [];

      for (const c of data.candidates) {
        if (!c._id) continue;

        // Check if visa is expired (RED status candidate)
        if (c.visaExpiry && isPastDate(c.visaExpiry)) {
          invalidCandidates.push(`${c.firstName || ""} ${c.lastName || ""}`.trim() + ` (Visa expired on ${dateFormat(c.visaExpiry)})`);
          continue;
        }

        const compliance = c.complianceCriteria || [];

        const getCriteria = (q) => compliance.find((item) => item.question === q);

        const passport = getCriteria("Passport");
        const brp = getCriteria("BRP");
        const rtw = getCriteria("RTW Documentation");

        // Modified to not require expiry date for passport
        const hasExpireAndFile = (doc) => Boolean(doc?.fileUrl);
        const hasFile = (doc) => Boolean(doc?.fileUrl);

        const isUKorIreland = ["United Kingdom", "Ireland"].includes(c.nationality);

        if (isUKorIreland) {
          console.log('===== DEBUG: UK/Ireland Candidate Check =====');
          console.log('Candidate:', `${c.firstName} ${c.lastName} (${c._id})`);
          console.log('Nationality:', c.nationality);
          console.log('All compliance criteria questions:', compliance.map(item => ({
            question: item.question,
            hasFile: !!item.fileUrl,
            fileUrl: item.fileUrl
          })));

          // Try to find the birth certificate with different variations
          const birthCertificateVariations = [
            "Birth certificate British and Irish",
            "Birth Certificate", 
            "Birth certificate", 
            "birth certificate", 
            "Birth Certificate Copy",
            "Birth certificate copy",
            "Birth Cert",
            "birth cert",
            "Birth Cert Copy"
          ];
          
          let birthCertificate = null;
          for (const variation of birthCertificateVariations) {
            birthCertificate = getCriteria(variation);
            if (birthCertificate) {
              console.log(`Found birth certificate with variation: "${variation}"`);
              break;
            }
          }
          
          const hasValidPassport = hasFile(passport);
          const hasValidBirthCert = hasFile(birthCertificate);
          
          console.log('Document Check Results:', { 
            hasPassport: hasValidPassport,
            hasBirthCert: hasValidBirthCert,
            birthCertFound: !!birthCertificate,
            birthCertQuestion: birthCertificate?.question,
            birthCertFile: birthCertificate?.fileUrl
          });
          
          if (!hasValidPassport && !hasValidBirthCert) {
            const errorMsg = `${c.firstName} ${c.lastName} (requires either passport copy or birth certificate)`;
            console.log('Marking as invalid:', errorMsg);
            invalidCandidates.push(errorMsg);
            continue;
          }
          
          console.log('Candidate passed all document checks');
        } else {
          const hasValidPassport = hasFile(passport);
          const hasValidBrp = hasExpireAndFile(brp);
          const hasValidRTW = hasExpireAndFile(rtw);

          // Allow assignment if at least one BRP file is uploaded
          const hasBrpFile = hasFile(brp);
          
          // Check if the candidate meets the requirements
          const hasValidDocuments = (hasValidPassport || hasValidBrp || hasBrpFile) && hasValidRTW;
          
          if (!hasValidDocuments) {
            const issues = [];
            if (!hasValidPassport && !hasValidBrp && !hasBrpFile) {
              issues.push("Passport or BRP");
            }
            if (!hasValidRTW) issues.push("RTW Documentation");
            
            invalidCandidates.push(`${c.firstName} ${c.lastName} (missing ${issues.join(" and ")})`);
            continue;
          }
        }

        // Passed all validation
        validCandidates.push(c);
      }

      if (invalidCandidates.length > 0) {
        toast.error(
          `These candidates are missing required compliance: ${invalidCandidates.join(", ")}`
        );
        return false;
      }

      if (validCandidates.length === 0) {
        toast.error("No valid candidates found");
        return false;
      }

      const payload = {
        ...data,
        candidates: validCandidates
      };

      const res = await put(`/api/job/${id}/hire`, payload, token);

      if (res.status === 200 || res.status === 201) {
        toast.success(`Successfully assigned ${validCandidates.length} candidate(s).`);
        const jobsRes = await get("/api/job", token);
        dispatch(getAllJobList(jobsRes));
        return true;
      } else {
        toast.error("Failed to assign candidates. Please try again.");
        dispatch(
          addJobFailedAction("Something went wrong while adding candidates. Please try again")
        );
        return false;
      }
    } catch (e) {
      console.error("Error in hireCandidate:", e);
      toast.error(`Failed to assign candidates: ${e.message || "Unknown error"}`);
      dispatch(
        addJobFailedAction("Something went wrong while adding candidates. Please try again")
      );
      return false;
    }
  };
}

export function extendJobWithCandidates(jobData, originalJobId, setModal, token) {
  return async (dispatch) => {
    try {
      const extendData = JSON.parse(JSON.stringify(jobData));
      
      if (extendData.jobStartDate) {
        extendData.jobStartDate = new Date(extendData.jobStartDate);
      }
      
      if (extendData.jobEndDate) {
        const endDate = new Date(extendData.jobEndDate);
        endDate.setHours(23, 59, 59, 999);
        extendData.jobEndDate = endDate;
      }
      
      const payload = {
        originalJobId,
        jobData: extendData,
        accessToken: jobData.accessToken 
      };
      
      const res = await post("/api/job/extend-with-candidates", payload, token);
      
      if (res.status === 200) {
        toast.success(res.data.message || "Job extended with candidates successfully.");
        
        const jobsRes = await get("/api/job", token);
        dispatch(getAllJobList(jobsRes));
        
        if (typeof setModal === 'function') {
          setModal(false);
        }
        
        return true;
      } else {
        const errorMsg = res.data?.message || "Failed to extend job with candidates.";
        toast.error(errorMsg);
        dispatch(addJobFailedAction(errorMsg));
        return false;
      }
    } catch (error) {
      console.error("Error extending job with candidates:", error);
      const errorMsg = error.response?.data?.message || error.message || "Something went wrong while extending job.";
      toast.error(errorMsg);
      dispatch(addJobFailedAction(errorMsg));
      return false;
    }
  };
}

export function copyJobWithoutCandidates(jobData, originalJobId, setModal, token) {
  return async (dispatch) => {
    try {
      const copyData = JSON.parse(JSON.stringify(jobData));
      
      if (copyData.jobStartDate) {
        copyData.jobStartDate = new Date(copyData.jobStartDate);
      }
      
      if (copyData.jobEndDate) {
        const endDate = new Date(copyData.jobEndDate);
        endDate.setHours(23, 59, 59, 999);
        copyData.jobEndDate = endDate;
      }
      const res = await post("/api/job", copyData, token);
      
      if (res.status === 200 || res.status === 201) {
        toast.success("Job copied successfully without candidates.");
        
        const jobsRes = await get("/api/job", token);
        dispatch(getAllJobList(jobsRes));
        
        if (typeof setModal === 'function') {
          setModal(false);
        }
        
        return true;
      } else {
        const errorMsg = res.data?.message || "Failed to copy job.";
        toast.error(errorMsg);
        dispatch(addJobFailedAction(errorMsg));
        return false;
      }
    } catch (error) {
      console.error("Error copying job:", error);
      const errorMsg = error.response?.data?.message || error.message || "Something went wrong while copying job.";
      toast.error(errorMsg);
      dispatch(addJobFailedAction(errorMsg));
      return false;
    }
  };
}
